import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvironmentLoaderService } from 'ok-angular-shared/services';
import { toCamelCase } from 'ok-angular-shared/utils';
import { map } from 'rxjs/operators';
import { AppSettings } from 'src/settings/appsettings.interface';

export const snakeCaseInterceptor: HttpInterceptorFn = (req, next) => {
  const environment = inject<EnvironmentLoaderService<AppSettings>>(EnvironmentLoaderService);

  if (req.url.includes(environment.config.subscriptionServiceBaseUrl)) {
    return next(req).pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body && req.responseType !== 'blob') {
          return event.clone({ body: toCamelCase(event.body) });
        }
        return event;
      })
    );
  }

  return next(req);
};
